import { useState } from 'react';
import { faqs } from '@/mocks/content';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <section id="faq" className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-100">
      <script type="application/ld+json">{JSON.stringify(faqJsonLd)}</script>
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 rounded-full bg-secondary-100 text-secondary-700 text-sm font-medium mb-4">
            常见问题
          </span>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
            您可能想问的问题
          </h2>
          <p className="text-foreground-600 leading-relaxed">
            这里整理了一些常见问题和解答，希望能帮到您
          </p>
        </div>

        <div className="flex flex-col gap-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="rounded-xl bg-background-50 border border-background-200/70 overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between px-6 py-5 text-left cursor-pointer hover:bg-background-50/80 transition-colors duration-200"
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
              >
                <span className="text-base font-medium text-foreground-900 pr-4">
                  {faq.question}
                </span>
                <i
                  className={`${openIndex === index ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'} text-foreground-400 text-lg flex-shrink-0 transition-transform duration-300`}
                ></i>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="px-6 pb-5 text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}